export * from './add-guests.component';



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/add-guests/index.ts